import { Injectable } from '@angular/core';

const STORAGE_KEY = 'raidOrganizer_preferences';

export interface UserPreferences {
  eventsViewMode: 'list' | 'calendar';
  eventCreationMode: 'simple' | 'advanced';
}

const DEFAULTS: UserPreferences = {
  eventsViewMode: 'list',
  eventCreationMode: 'advanced',
};

@Injectable({ providedIn: 'root' })
export class UserPreferencesService {
  private prefs: UserPreferences = { ...DEFAULTS };

  constructor() {
    this.load();
  }

  private load(): void {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw) as Partial<UserPreferences>;
        this.prefs = { ...DEFAULTS, ...parsed };
      }
    } catch {
      this.prefs = { ...DEFAULTS };
    }
  }

  private save(): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.prefs));
    } catch {}
  }

  get eventsViewMode(): 'list' | 'calendar' {
    return this.prefs.eventsViewMode;
  }

  set eventsViewMode(value: 'list' | 'calendar') {
    this.prefs.eventsViewMode = value;
    this.save();
  }

  get eventCreationMode(): 'simple' | 'advanced' {
    return this.prefs.eventCreationMode;
  }

  set eventCreationMode(value: 'simple' | 'advanced') {
    this.prefs.eventCreationMode = value;
    this.save();
  }
}
